module.exports = __webpack_public_path__ + "static/media/02n.e7e92237.svg";